import { Dispatch, SetStateAction } from 'react';

export enum MinimalCartEntryType {
  item = 'item',
  combo = 'combo',
  modifier = 'modifier',
  incentive = 'incentive',
  discount = 'discount',
  reward = 'reward',
  donation = 'donation',
  extra = 'extra',
}

export type CartState = {
  debug: boolean;
};

export type CartContext = CartState & {
  setCartState: Dispatch<SetStateAction<CartState>>;
};
